import type { FC } from 'react'

import { Input } from '@skytech/ui'
import { getLocaleTimezoneIsoDate, getMaxDate } from '@skytech/utils'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'

import './indetification.scss'

const Identification: FC<{ isEditable: boolean }> = ({ isEditable }) => (
  <section className="identification">
    <h3>
      <Text id="Identifikasjon" />
    </h3>

    <div className="inputs">
      <Field name="idNumber">
        {({ field, meta }: FieldProps) => (
          <Input
            id="idNumber"
            marginRight={16}
            label={<Text id="ID på bankkort, kontrollnummer eller førerkortnummer" />}
            error={meta.error}
            touched={meta.touched}
            isDisabled={!isEditable}
            {...field}
          />
        )}
      </Field>

      <Field name="personalId">
        {({ field, meta }: FieldProps) => (
          <Input
            type="date"
            id="personalId"
            label={<Text id="Hva er din fødselsdato?" />}
            error={meta.error}
            touched={meta.touched}
            // Any date in the past - a person can not (yet) be born in the future
            max={getLocaleTimezoneIsoDate(getMaxDate(0))}
            isDisabled={!isEditable}
            autoComplete="bday"
            {...field}
          />
        )}
      </Field>
    </div>
  </section>
)

export default Identification
